import { render, staticRenderFns } from "./DashboardLastOrder.vue?vue&type=template&id=5ab457ea&scoped=true"
import script from "./DashboardLastOrder.vue?vue&type=script&lang=ts"
export * from "./DashboardLastOrder.vue?vue&type=script&lang=ts"
import style0 from "./DashboardLastOrder.vue?vue&type=style&index=0&id=5ab457ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab457ea",
  null
  
)

export default component.exports